import { captureAuthorizationRequest } from './features/integration-authorizations/lib/authorization-bootstrap.ts'

captureAuthorizationRequest({
  pathname: window.location.pathname,
  hash: window.location.hash,
  clearHash: () => {
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${window.location.search}`,
    )
  },
})

void import('./main.tsx')
